import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import {
  MeterReplaceAttachModalComponent
} from '@shared/modals/meter/meter-replace-attach-modal/meter-replace-attach-modal.component';

export const meterReplaceAttachModalConfig: ModalConfig = {
  component: MeterReplaceAttachModalComponent,
  title: 'meter.replaceAttach.attach.title',
  size: 'xl',
  actions: [
    {
      type: 'primary',
      label: 'common.attach',
      method: 'attachOrReplace'
    },
    {
      type: 'secondary',
      label: 'system.button.cancel',
      closeOnClick: true
    },
  ],
}
